var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C19 19.5317 18.9894 19.019 18.8711 18.6289C18.5802 17.6702 17.8298 16.9198 16.8711 16.6289C16.481 16.5106 15.9683 16.5 14.5 16.5H9.49997C8.03165 16.5 7.51894 16.5106 7.12888 16.6289C6.17019 16.9198 5.41974 17.6702 5.12888 18.6289C5.01055 19.019 4.99997 19.5317 4.99997 21C4.99997 21.5523 4.55225 22 3.99997 22C3.44768 22 2.99997 21.5523 2.99997 21C2.99997 19.6774 2.98877 18.7943 3.21481 18.0488C3.69956 16.4508 4.95079 15.1996 6.5488 14.7148C7.29425 14.4888 8.17737 14.5 9.49997 14.5H14.5C15.8226 14.5 16.7057 14.4888 17.4511 14.7148C19.0491 15.1996 20.3004 16.4508 20.7851 18.0488C21.0112 18.7943 21 19.6774 21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21ZM15.5 7.5C15.5 5.567 13.933 4 12 4C10.067 4 8.49997 5.567 8.49997 7.5C8.49997 9.433 10.067 11 12 11C13.933 11 15.5 9.433 15.5 7.5ZM17.5 7.5C17.5 10.5376 15.0375 13 12 13C8.9624 13 6.49997 10.5376 6.49997 7.5C6.49997 4.46243 8.9624 2 12 2C15.0375 2 17.5 4.46243 17.5 7.5Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cd35d69a.svg";
export { ForwardRef as ReactComponent };